import { render, staticRenderFns } from "./ReplacementList.vue?vue&type=template&id=7e4d36de&scoped=true"
import script from "./ReplacementList.vue?vue&type=script&lang=js"
export * from "./ReplacementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4d36de",
  null
  
)

export default component.exports